import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

function ProjectIcon(props: SvgIconProps) {
  return (
    <SvgIcon height="16" viewBox="0 0 17 16" width="17" fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="M15.8335 7.33398C15.8335 10.6477 13.1472 13.334 9.83347 13.334C9.77614 13.334 9.71901 13.3332 9.66207 13.3316V13.334H0.747803V11.9626H6.01532C4.68275 10.8621 3.83347 9.1972 3.83347 7.33398C3.83347 4.02027 6.51976 1.33398 9.83347 1.33398C13.1472 1.33398 15.8335 4.02027 15.8335 7.33398ZM9.83345 10.334C11.4903 10.334 12.8335 8.99084 12.8335 7.33398C12.8335 5.67713 11.4903 4.33398 9.83345 4.33398C8.1766 4.33398 6.83345 5.67713 6.83345 7.33398C6.83345 8.99084 8.1766 10.334 9.83345 10.334Z"
        fill="#009FDF"
        fillRule="evenodd"
        transform="rotate(180,8.5,8)"
      />
    </SvgIcon>
  );
}

export default ProjectIcon;
